import { Injectable, computed, signal } from '@angular/core';

import { LocalStorageKeys } from 'src/app/configs/local-storage-keys-config';

@Injectable({
  providedIn: 'root',
})
export class UseSeparatorService {
  #useSeparator = signal<boolean>(
    localStorage.getItem(LocalStorageKeys.isUseSeparator)
      ? JSON.parse(localStorage.getItem(LocalStorageKeys.isUseSeparator))
      : true
  );

  useSeparator = computed(this.#useSeparator);

  setUseSeparator(useSeparator: boolean) {
    this.#useSeparator.set(useSeparator);
  }
}

